/**
 * D22 — client-filter public SP rows by name / location / tenantName (case-insensitive).
 * Used after full drain for with-q `entity=shop` and Vše Obchody (no name API).
 */

import { matchesDirectoryQuery } from '../../shared/ui/directoryListFilter.js';
import type { PublicCustomerSalesPointDTO } from '../shops/publicSalesPointsApi.js';

export function filterBrowseShopDirectoryByQuery(
  items: readonly PublicCustomerSalesPointDTO[],
  query: string,
): PublicCustomerSalesPointDTO[] {
  return items.filter((item) =>
    matchesDirectoryQuery([item.name, item.location, item.tenantName], query),
  );
}
